import styles from "./styles.scss";
import { FC } from "react";
import { NavLink, useLocation } from "react-router-dom";
import clsx from "clsx";
import { SideNavigationItemProps } from "./types";
import { BasicRoutePath } from "@/constants";

export const SideNavigationItem: FC<SideNavigationItemProps> = ({
  iconElement: Icon,
  iconElementActive: IconActive,
  path,
  title,
  onClick,
}) => {
  const { pathname } = useLocation();

  const handleMenuItemClick = () => {
    if (onClick) {
      onClick();
    }
  };

  // Hack for approvals active NavLink
  // issue: https://github.com/remix-run/react-router/issues/9279
  const isApprovals =
    pathname?.includes(BasicRoutePath.Approvals) &&
    path === BasicRoutePath.Approvals;

  const isContractor =
    pathname?.includes(BasicRoutePath.ContractorProfile) &&
    path === BasicRoutePath.ContractorProfile;

  const isRequest =
    pathname?.includes(BasicRoutePath.Requests) &&
    path === BasicRoutePath.Requests;

  return (
    <NavLink
      to={path}
      className={({ isActive }) =>
        clsx(
          styles.listItem,
          (isActive || isApprovals || isContractor || isRequest) &&
            styles.listItemActive,
        )
      }
      onClick={handleMenuItemClick}
      end
    >
      <div className={styles.listItemIconWrapper}>
        <Icon className={styles.listItemIcon} />
        <IconActive className={styles.listItemIconActive} />
      </div>
      <p className={styles.listItemTitle}>{title}</p>
    </NavLink>
  );
};
